<ion-content class="order-details-container ion-padding">
  <ion-text class="ion-text-center">
    <h4>
      {{ 'order-details-popover.Programación'  | translate }}
    </h4>
  </ion-text>

  <ion-list>
    <ion-item *ngFor="let item of details">
      <ion-label>
        <ion-text>
          <p><strong>{{item.descripcion}}</strong></p>
        </ion-text>
        <ion-text class="ion-text-wrap" color="medium">
          <p>
            <ion-icon name="build" slot="start"> </ion-icon> {{ item.ejecutor.name || ( 'order-details-popover.Sin ejecutor'  | translate ) | titlecase }}
            &bull; {{ 'order-details-popover.DNI:'  | translate }}
            {{ item.ejecutor.rut }}
          </p>
        </ion-text>
        <ion-text class="ion-text-wrap" color="medium">
          <p>
            <ion-icon name="calendar" slot="start"> </ion-icon>
            {{ utils.changeDateSeparator(item.fecha_inicio) | date: 'EEE dd/MM' : '' : culture }} {{ 'order-details-popover.de'  | translate }}
            {{ utils.changeDateSeparator(item.fecha_inicio) | date: 'HH:mm' }} {{ 'order-details-popover.a'  | translate }}
            {{ utils.changeDateSeparator(item.fecha_fin) | date: 'HH:mm' }} &bull;
            <span>{{ utils.getHoursAndMinutes(item.duracion) }} </span>
          </p>
        </ion-text>
      </ion-label>
    </ion-item>
  </ion-list>

</ion-content>